import type { CheckboxPropOnChange } from 'uikit';
import { Checkbox } from 'uikit';

import type React from 'react';

interface ICheckRowCell {
    row: any;
    onChange?: CheckboxPropOnChange | undefined;
    checkedIds: Record<string, boolean>;
    disabled: boolean;
}

export const CheckRowCell: React.FC<ICheckRowCell> = (props) => {
    const { onChange, row, checkedIds, disabled } = props;

    const { id } = row;

    return <Checkbox disabled={disabled} checked={checkedIds[id]} onChange={onChange} />;
};

CheckRowCell.displayName = 'CheckRowCell';
